<template>
  <wt-paged-table 
    ref="table" 
    class="pt-gene-lab-order-table__withData" 
    :isAddPageToRouter="true" 
    :on-request-data="getTableData" 
    :total-size="totalNumber" 
    :page-size="pageSize" 
    :refresh="true" 
    layout="sizes,total, prev, pager, next,jumper"
    :pageSizes="[10, 25, 50, 100, 500, 1000, 2000]"
    @size-change="handleSizeChange"
  >
    <base-table
        :columns="tableLabels"
        selectType="checkbox"
        :table-data="tableData"
        @selection-change="handleSelectionChange"
      >
      <template slot="orderStatus" slot-scope="scope">
        <slot :row="scope.row" name="orderStatus"></slot>
      </template>
      <template slot="operate" slot-scope="scope">
        <slot :row="scope.row"></slot>
      </template>
    </base-table>
  </wt-paged-table>
</template>

<script>
// 组件class前缀
const prefixCls = 'pt-gene-lab-order-table'
export default {
  name: 'pt-gene-lab-order-table',
  computed: {
    classes () {
      return `${prefixCls}`
    },
  },
  props: {
    tableData: {
      type: Array,
      default: () => []
    },
    tableLabels: {
      type: Array,
      default: () => []
    },
    totalNumber: {
      type: Number,
      default: 0
    },
    pageSize: {
      type: Number,
      default: 0
    },
    requestData: {
      type: Function
    },
    category: {
      type: String,
      default: ''
    }
  },
  methods: {
    handleSizeChange (val) {
      this.$emit('size-change', val)
    },
    getTableData (page, next) {
      this.requestData && this.requestData(page, next)
    },
    resetPage(){
      this.$refs.table.resetPage()
    },
    reload () {
      this.$refs.table.load()
    },
    showReTry () {
      this.$refs.table.showReTry()
    },
    handleSelectionChange(val){
      this.$emit('selection-change',val)
    }
  }
}
</script>